module.exports = __webpack_public_path__ + "img/7_001.7d93c564.webp";